import React, { useCallback, useEffect, useState } from 'react';
import { bekendeStatus, haalTweestapsStatus } from '../../services/tweestapsService';
import TweestapsCode from './TweestapsCode';
import TweestapsKoppelen from './TweestapsKoppelen';
import './Tweestaps.css';

/**
 * Poort vóór de docent- en beheerpagina's (22-10-2026, migratie 105).
 *
 * Wie met e-mail en wachtwoord inlogt als docent of beheerder, ziet eerst:
 *   - "Nog één stap": de code uit de authenticator-app (als er een app gekoppeld is);
 *   - "Beveilig je account": een app koppelen (als de tweede stap verplicht is).
 * Pas daarna de pagina zelf. Entree-accounts en leerlingen merken niets.
 *
 * De server houdt hetzelfde tegen (RLS, PostgREST en de backend); deze poort zorgt
 * dat de gebruiker ziet wat hij moet doen in plaats van lege pagina's.
 */
function TweestapsPoort({ gebruikerId, onUitloggen, children }) {
  const [uitkomst, setUitkomst] = useState(() => bekendeStatus(gebruikerId));
  const [naHerstel, setNaHerstel] = useState(false);

  const controleer = useCallback(async (vers = false) => {
    try {
      setUitkomst(await haalTweestapsStatus({ vers }));
    } catch {
      // Status niet op te halen: door. De server weigert wat niet mag.
      setUitkomst({ stap: 'ok', status: null, aal: null, email: null });
    }
  }, []);

  useEffect(() => { controleer(); }, [controleer, gebruikerId]);

  if (!uitkomst) {
    return <div className="ts-laden" aria-label="Laden"><div className="ts-draaier" /></div>;
  }
  if (uitkomst.stap === 'ok' && !naHerstel) return children;

  const toonKoppelen = uitkomst.stap === 'koppelen' || (naHerstel && uitkomst.stap === 'ok');

  return (
    <div className="ts-pagina">
      <div className="ts-kaart">
        <img src="/tw-logo-02.png" alt="TestWisely" className="ts-logo" />
        {uitkomst.stap === 'code' && (
          <>
            <h1>Nog één stap</h1>
            <p className="ts-uitleg">Vul de code in die je authenticator-app nu toont.</p>
            <TweestapsCode
              onKlaar={() => controleer(true)}
              onHersteld={async () => { setNaHerstel(true); await controleer(true); }}
            />
          </>
        )}
        {toonKoppelen && (
          <>
            <h1>{naHerstel ? 'Koppel je nieuwe telefoon' : 'Beveilig je account'}</h1>
            <p className="ts-uitleg">
              {naHerstel
                ? 'Je oude telefoon is losgekoppeld. Koppel nu de app op je nieuwe telefoon.'
                : 'Na je wachtwoord vragen we voortaan een code uit een app op je telefoon. Zo komt niemand met alleen je wachtwoord bij de gegevens van je leerlingen.'}
            </p>
            <TweestapsKoppelen
              email={uitkomst.email}
              onKlaar={async () => { setNaHerstel(false); await controleer(true); }}
              onAnnuleer={uitkomst.stap === 'ok' ? () => setNaHerstel(false) : null}
            />
          </>
        )}
        <button type="button" className="ts-link ts-link-stil" onClick={onUitloggen}>Uitloggen</button>
      </div>
    </div>
  );
}

export default TweestapsPoort;
